import * as Sentry from "@sentry/react";
import {ZodError} from "zod";

const handleZodError = <T>({error, defaultData}: {error: Error; defaultData: T}) => {
	if (error instanceof ZodError) {
		// ZodError는 여러 개의 오류를 포함할 수 있음
		const errorMessage = error.issues.map((err) => {
			// 오류의 path와 메시지를 추출하여 사용자에게 이해하기 쉽게 출력
			return `Field '${err.path.join(".")}' ${err.message}`;
		});
		console.error(errorMessage);
		Sentry.captureException(error);
	} else {
		// 다른 타입의 오류 처리 (예: API 호출 실패 등)
		console.error([error.message || "Unknown error occurred"]);
		Sentry.captureException(error.message || "Unknown error occurred");
	}
	
	return defaultData;
};

export {handleZodError};
